function pickNumber(
  record: Record<string, unknown>,
  keys: string[],
): number {
  for (const key of keys) {
    const v = record[key];
    if (v == null || v === "") continue;
    const n = Number(v);
    if (Number.isFinite(n)) return n;
  }
  return 0;
}

export function formatRefundCurrency(value: number): string {
  const n = Number.isFinite(value) ? value : 0;
  return `₹${n.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/** Matches Edit Refund dialog amount display (`—` when empty). */
export function formatRefundAmountDisplay(
  amount: number | null | undefined,
): string {
  if (amount == null || !Number.isFinite(amount)) return "—";
  return formatRefundCurrency(amount);
}

/** Payment total — display only in the refund dialog; proposed refund may be up to this value. */
export function resolvePaymentRefundDialogAmounts(
  payment: Record<string, unknown>,
): { total: number } {
  return {
    total: pickNumber(payment, [
      "amount",
      "totalpayment",
      "totalPayment",
      "totalpayableamount",
    ]),
  };
}

export function parseRefundAmountInput(value: string): number | null {
  const trimmed = value.trim();
  if (trimmed === "") return null;
  const n = Number.parseFloat(trimmed.replace(/,/g, ""));
  if (!Number.isFinite(n) || n < 0) return null;
  return n;
}

export type BulkRefundSelectionRow = {
  amount: string | number;
  refundableamount: number | null;
};

export function resolveBulkRefundDialogAmounts(
  rows: BulkRefundSelectionRow[],
): { total: number } {
  let total = 0;
  for (const row of rows) {
    total += pickNumber(
      { amount: row.amount } as Record<string, unknown>,
      ["amount"],
    );
  }
  return { total };
}

/** Default proposed refund to full payment total (single selection). */
export function defaultRefundAmountInput(
  rows: BulkRefundSelectionRow[],
): string {
  if (rows.length !== 1) return "";
  const n = pickNumber(
    { amount: rows[0].amount } as Record<string, unknown>,
    ["amount"],
  );
  return n > 0 ? String(n) : "";
}
